var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3859 8.85143L16.8105 2.5H15.5248L10.8159 8.01464L7.05303 2.5H2.71375L8.40303 10.84L2.71375 17.5H3.99946L8.97303 11.6757L12.947 17.5H17.2862L11.3859 8.85143ZM9.62553 10.9129L9.0491 10.0825L4.46232 3.475H6.43696L10.1377 8.8075L10.7141 9.63786L15.5259 16.57H13.5512L9.62553 10.9129Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.900f12195660da7c0b698c71e4a9b3f5.svg";
export { ForwardRef as ReactComponent };